import { getNotificationUnreadCount } from "@/services";
import { useAuthStore } from "@/store/authStore";
import { NOTIFICATION_QUERY_KEYS } from "@/types";
import { useQuery } from "@tanstack/react-query";
import { isNil } from "lodash";

export function useGetUnreadCount() {
  // khi user thay đổi, refetch lại
  const { user } = useAuthStore();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [NOTIFICATION_QUERY_KEYS.UNREAD_COUNT, user?.id],
    queryFn: () => getNotificationUnreadCount(),
    retry: 1,
    refetchInterval: 5 * 60 * 1000, // Tự động refetch mỗi 5 phút
    enabled: !isNil(user), // Chỉ chạy query khi user khác null
  });

  return {
    unreadCount: data?.data || 0,
    isLoading,
    error,
    refetch,
  };
}
